/* Lounelle — mobile PDP gallery UI only.
 * Zoom ownership lives exclusively in assets/zoom.js.
 */
(function () {
  'use strict';

  var MOBILE = window.matchMedia('(max-width: 767px)');
  var ROOT_SELECTOR = 'product-info';
  var SLIDER_SELECTOR = '[data-product-single-media-slider]';
  var SLIDE_SELECTOR = '[data-product-single-media-wrapper]';
  var MAX_DOTS = 7;

  function isProductPage() {
    return document.body && document.body.classList.contains('template-product');
  }

  function getSlides(slider) {
    return slider ? Array.prototype.slice.call(slider.querySelectorAll(SLIDE_SELECTOR)) : [];
  }

  function getFlickity(slider) {
    try {
      return window.theme && window.theme.Flickity && window.theme.Flickity.data
        ? window.theme.Flickity.data(slider)
        : null;
    } catch (_) {
      return null;
    }
  }

  function syncFlickityLayout(flkty) {
    if (!flkty) return;

    var selected = typeof flkty.selectedIndex === 'number' ? flkty.selectedIndex : 0;

    window.requestAnimationFrame(function () {
      var maxIndex = flkty.cells && flkty.cells.length ? flkty.cells.length - 1 : selected;
      var safeIndex = Math.max(0, Math.min(selected, maxIndex));

      if (typeof flkty.resize === 'function') {
        flkty.resize();
      } else if (typeof flkty.reposition === 'function') {
        flkty.reposition();
      }

      if (safeIndex !== selected && typeof flkty.select === 'function') {
        flkty.select(safeIndex, false, true);
      }
    });
  }

  function createDots(root, slider, total) {
    var old = root.querySelector('.lounelle-gallery-dots');
    if (old) old.remove();
    if (total < 2) return null;

    var dots = document.createElement('div');
    dots.className = 'lounelle-gallery-dots';
    dots.setAttribute('aria-hidden', 'true');

    var count = Math.min(total, MAX_DOTS);
    for (var index = 0; index < count; index += 1) {
      var dot = document.createElement('span');
      dot.className = 'lounelle-gallery-dot';
      dots.appendChild(dot);
    }

    slider.appendChild(dots);
    return dots;
  }

  function createCounter(root, slider, total) {
    var old = root.querySelector('.lounelle-gallery-counter');
    if (old) old.remove();
    if (total < 2) return null;

    var counter = document.createElement('div');
    counter.className = 'lounelle-gallery-counter';
    counter.setAttribute('aria-hidden', 'true');
    counter.textContent = '1 / ' + total;
    slider.appendChild(counter);
    return counter;
  }

  function createZoomButton(root, slider) {
    var old = root.querySelector('.lounelle-gallery-zoom');
    if (old) old.remove();

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'lounelle-gallery-zoom';
    button.setAttribute('aria-label', root.dataset.lounelleZoomLabel || '');
    button.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="10.8" cy="10.8" r="6.4"></circle><path d="M15.5 15.5 21 21M10.8 7.7v6.2M7.7 10.8h6.2"></path></svg>';
    slider.appendChild(button);
    return button;
  }

  function updateDots(dots, index, total) {
    if (!dots) return;

    var visible = dots.children.length;
    var start = 0;

    if (total > visible) {
      start = index - Math.floor(visible / 2);
      start = Math.max(0, Math.min(start, total - visible));
    }

    Array.prototype.forEach.call(dots.children, function (dot, slot) {
      var representedIndex = start + slot;
      var active = representedIndex === index;

      dot.dataset.index = String(representedIndex);
      dot.classList.toggle('is-active', active);
      dot.classList.toggle(
        'is-edge',
        total > visible &&
          !active &&
          (slot === 0 || slot === visible - 1) &&
          ((slot === 0 && start > 0) || (slot === visible - 1 && start + visible < total))
      );
    });
  }

  function setUiIndex(dots, counter, index, total) {
    updateDots(dots, index, total);
    if (counter) counter.textContent = (index + 1) + ' / ' + total;
  }

  function initGallery(root) {
    if (!MOBILE.matches || !root || root.dataset.lounelleMobileGallery === 'true') return;

    var slider = root.querySelector(SLIDER_SELECTOR);
    if (!slider) return;

    var slides = getSlides(slider);
    if (!slides.length) return;

    root.dataset.lounelleMobileGallery = 'true';
    root.classList.add('lounelle-mobile-gallery-ready');

    var dots = createDots(root, slider, slides.length);
    var counter = createCounter(root, slider, slides.length);
    var zoomButton = createZoomButton(root, slider);
    var flkty = getFlickity(slider);
    var lastTotal = slides.length;

    if (slides.length > 1 && !flkty) {
      var attempts = parseInt(root.dataset.lounelleGalleryAttempts || '0', 10);
      if (attempts < 12) {
        root.dataset.lounelleGalleryAttempts = String(attempts + 1);
        root.dataset.lounelleMobileGallery = '';
        root.classList.remove('lounelle-mobile-gallery-ready');
        if (dots) dots.remove();
        if (counter) counter.remove();
        if (zoomButton) zoomButton.remove();

        window.setTimeout(function () {
          initGallery(root);
        }, 70);
        return;
      }
    }

    delete root.dataset.lounelleGalleryAttempts;

    function currentSlides() {
      return getSlides(slider);
    }

    function selectedIndex() {
      if (flkty && typeof flkty.selectedIndex === 'number') return flkty.selectedIndex;

      var liveSlides = currentSlides();
      var selected = slider.querySelector(SLIDE_SELECTOR + '.is-selected');
      return Math.max(0, liveSlides.indexOf(selected));
    }

    function rebuildUiIfNeeded() {
      var total = currentSlides().length;
      if (total === lastTotal) return total;

      lastTotal = total;
      dots = createDots(root, slider, total);
      counter = createCounter(root, slider, total);
      return total;
    }

    function update() {
      var total = rebuildUiIfNeeded();
      if (!total) return;

      var idx = Math.max(0, Math.min(selectedIndex(), total - 1));
      setUiIndex(dots, counter, idx, total);

      var current = currentSlides()[idx];
      zoomButton.classList.toggle('is-hidden', !current || current.dataset.type !== 'image');
    }

    function openSelectedWithNativeZoom() {
      var liveSlides = currentSlides();
      if (!liveSlides.length) return;

      var idx = Math.max(0, Math.min(selectedIndex(), liveSlides.length - 1));
      var current = liveSlides[idx];
      var wrapper = current && current.querySelector('[data-zoom-wrapper]');
      if (wrapper) wrapper.click();
    }

    zoomButton.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      openSelectedWithNativeZoom();
    });

    if (flkty) {
  var clarityDragStartIndex = null;
  var clarityDragEnded = false;

  flkty.on('dragStart', function () {
    clarityDragStartIndex = flkty.selectedIndex;
    clarityDragEnded = false;
  });

  flkty.on('dragEnd', function () {
    clarityDragEnded = true;
  });

  flkty.on('select', update);

  flkty.on('settle', function () {
    update();

    if (!clarityDragEnded || clarityDragStartIndex === null) return;

    var changedSlide = flkty.selectedIndex !== clarityDragStartIndex;

    clarityDragStartIndex = null;
    clarityDragEnded = false;

    if (
      !changedSlide ||
      root.dataset.clarityProductGallerySwipe === 'true'
    ) {
      return;
    }

    root.dataset.clarityProductGallerySwipe = 'true';

    if (typeof window.clarity === 'function') {
      window.clarity('event', 'product_gallery_swipe');
      window.clarity('set', 'product_gallery_swiped', 'true');
    }
  });
}

    var observer = new MutationObserver(function (mutations) {
      var mediaChanged = mutations.some(function (mutation) {
        var nodes = Array.prototype.slice.call(mutation.addedNodes)
          .concat(Array.prototype.slice.call(mutation.removedNodes));

        return nodes.some(function (node) {
          return node.nodeType === 1 &&
            ((node.matches && node.matches(SLIDE_SELECTOR)) ||
             (node.querySelector && node.querySelector(SLIDE_SELECTOR)));
        });
      });

      if (!mediaChanged) return;

      window.requestAnimationFrame(function () {
        if (flkty) syncFlickityLayout(flkty);
        update();
      });
    });

    observer.observe(slider, { childList: true });

    if (flkty) syncFlickityLayout(flkty);
    update();
  }

  function initAll(scope) {
    if (!isProductPage() || !MOBILE.matches) return;

    var container = scope || document;
    if (container.matches && container.matches(ROOT_SELECTOR)) initGallery(container);
    Array.prototype.forEach.call(container.querySelectorAll(ROOT_SELECTOR), initGallery);
  }

  function boot() {
    if (!isProductPage()) return;

    initAll(document);

    document.addEventListener('theme:product-info:loaded', function (event) {
      var target = event.target && event.target.closest
        ? (event.target.closest(ROOT_SELECTOR) || event.target)
        : event.target;

      window.requestAnimationFrame(function () {
        if (target) initGallery(target);
      });
    });

    document.addEventListener('shopify:section:load', function (event) {
      window.requestAnimationFrame(function () {
        initAll(event.target);
      });
    });

    if (MOBILE.addEventListener) {
      MOBILE.addEventListener('change', function (event) {
        if (event.matches) initAll(document);
      });
    } else if (MOBILE.addListener) {
      MOBILE.addListener(function (event) {
        if (event.matches) initAll(document);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
